import { render } from "./ItemModal.vue?vue&type=template&id=913e6096&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "./ItemModal.vue?vue&type=style&index=0&id=913e6096&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913e6096"]])

export default __exports__